
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import HeaderUserInfoDropdown from "./HeaderUserInfoDropdown.vue";

const AppbarStore = namespace("Appbar");
const PedidoStore = namespace("Pedido");
const AuthStore = namespace("Auth");
@Component({
  name: "HeaderButtons",
  components: {
    HeaderUserInfoDropdown,
  },
})
export default class HeaderButtons extends Vue {
  @AppbarStore.Getter
  private getAppbarStatus!: any;

  @PedidoStore.Getter
  private getTotalProdutosPedido!: number;

  @AuthStore.Getter
  private isLoggedIn!: boolean;

  @AuthStore.Getter
  private getLoginDialogStatus!: any;


  get mobileViewport() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  onCartClick() {
    this.getAppbarStatus.carrinhoDrawer = !this.getAppbarStatus.carrinhoDrawer;
  }

  onUserClick() {
    this.getLoginDialogStatus.visible = true;
  }

  onViewMyAccountClick() {
    this.$router.push({ path: "/account" });
  }
}
